
  export default {
    name: "TimeSlider",
    props: {
      start: {
        type: String,
        required: true,
      },
      end: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
      };
    },
    methods: {
      toHundreds(value) {
        return (value * 100 ) / 1440
      },
      getMinutes(hour) {
        let hh = this.$moment(hour, 'HH:mm').get('hour');
        let mm = this.$moment(hour, 'HH:mm').get('minutes');
        return this.toHundreds(hh*60 + mm)
      },
      localFormat(hour) {
        let locale = this.$i18n.locale
        if (locale != 'en') {
          return this.$moment(hour, 'HH:mm').format("HH:mm");
        }
        return this.$moment(hour, 'HH:mm').format("hh:mm A");
      },
      isSliderTooshort(start, end){
        const mindifference = 30;
        let diff = Math.abs(start - end);

        return mindifference < diff || diff == 0;
      }
    },
    mounted() {
    },
    computed: {
    }
  };
